import { z } from 'zod';

const moduloSchema = z.object({
  catalogo_id: z.number().nullable().optional(),
  modelo_outro: z.string().nullable().optional(),
  quantidade: z.number().int().min(1, 'Quantidade mínima: 1'),
});

const inversorSchema = z.object({
  catalogo_id: z.number().nullable().optional(),
  modelo_outro: z.string().nullable().optional(),
  quantidade: z.number().int().min(1, 'Quantidade mínima: 1'),
  potencia_kw: z.number().min(0, 'Potência obrigatória'),
  ordem: z.number().int().min(1).max(3),
});

export const step2Schema = z.object({
  // Proposta
  valor_proposta: z.number().positive('Valor obrigatório').optional(),
  origem_lead: z.string().optional(),
  pre_vendedor: z.string().optional(),
  proposta_crm: z.boolean().optional(),
  numero_proposta: z.string().optional(),
  modo_pagamento: z.enum(['avista', 'parcelado_local', 'parcelado_remoto']).optional(),
  descricao_pagamento: z.string().optional(),
  payload_financeiro: z.any().optional(),
  contrato_com_seguro: z.boolean(),

  // Padrão
  tipo_padrao: z.enum(['Individual', 'Coletivo']).optional(),
  todas_contas_mesmo_titular: z.enum(['Sim', 'Nao']).optional(),
  corrente_padrao: z.string().optional(),
  fases_disjuntor: z.enum(['Monofasico', 'Bifasico', 'Trifasico']).optional(),
  descricao_padrao: z.string().optional(),

  // Equipamentos
  modulos: z.array(moduloSchema).optional(),
  inversores: z.array(inversorSchema).min(1, 'Ao menos 1 inversor'),
});

export type Step2Data = z.infer<typeof step2Schema>;
